import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* gettraningHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "training", ...action.payload }),
		);
		yield put({
			type: types.GET_TRANING_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_TRANING_ERROR,
			payload,
		});
	}
}

export function* gettraningWatcherSaga() {
	yield takeLatest(types.GET_TRANING_START, gettraningHandlerSaga);
}

//create

//delete

function* deletetraningHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("training", action.payload),
		);
		yield put({
			type: types.DELETE_TRANING_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_TRANING_ERROR,
			payload,
		});
	}
}

export function* deletetraningWatcherSaga() {
	yield takeLatest(types.DELETE_TRANING_START, deletetraningHandlerSaga);
}

//update
